import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SubMenu } from "../../../components";
import ApplicationCalendar from "./ApplicationCalendar";
import Download from "./Download";
import style from "./style.module.scss";

const InfoSelector = ({ product }) => {
  // React i18next
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState("whenToUse");
  const options = [
    {
      title: t("When to use"),
      slug: "whenToUse",
    },
    {
      title: t("How to use"),
      slug: "howToUse",
    },
    {
      title: t("Composition"),
      slug: "composition",
    },
    {
      title: t("Precaution of use"),
      slug: "precautionOfUse",
    },
    {
      title: t("Regulatory information"),
      slug: "regulatoryInformation",
    },
    {
      title: t("Download"),
      slug: "download",
    },
  ];

  return (
    <div className={style.block}>
      <div className={style.selectorBorder}>
        <SubMenu arrowLeftBgColor={style.lightBeige} className={style.selector}>
          {options.map(
            (option) =>
              (product[option.slug] ||
                option.slug === "whenToUse" ||
                (option.slug === "download" &&
                  product.files &&
                  product.files[0].title !== "" &&
                  product.files[0].url !== null &&
                  product.files[0].url !== "")) && (
                <h2
                  key={option.slug}
                  className={clsx(
                    style.option,
                    selectedOption === option.slug && style.selectedOption
                  )}
                  onClick={() => setSelectedOption(option.slug)}
                >
                  {option.title}
                </h2>
              )
          )}
        </SubMenu>
      </div>

      <div className={style.info}>
        {
          {
            whenToUse: <ApplicationCalendar whenToUse={product.whenToUse} />,
            howToUse: (
              <div
                className={style.textInfo}
                dangerouslySetInnerHTML={{
                  __html: product.howToUse,
                }}
              />
            ),
            composition: (
              <div
                className={style.textInfo}
                dangerouslySetInnerHTML={{
                  __html: product.composition,
                }}
              />
            ),
            precautionOfUse: (
              <div
                className={style.textInfo}
                dangerouslySetInnerHTML={{
                  __html: product.precautionOfUse,
                }}
              />
            ),
            regulatoryInformation: (
              <div
                className={clsx(style.textInfo, style.regulatoryInfo)}
                dangerouslySetInnerHTML={{
                  __html: product.regulatoryInformation,
                }}
              />
            ),
            download: <Download files={product.files} />,
          }[selectedOption]
        }
      </div>
    </div>
  );
};

export default InfoSelector;
